import React, { createContext } from 'react';
import './mimic-user-lib.module.scss';

/* eslint-disable-next-line */
export interface MimicUserLibProps { }

export interface iMimicUserContext {
  userId: string;
  setUserId: React.Dispatch<React.SetStateAction<string>>;
  role: number;
  setRole: React.Dispatch<React.SetStateAction<number>>;
}

export const MimicUserContext = createContext<iMimicUserContext>({
  userId: '',
  setUserId: () => { },
  role: 0,
  setRole: () => { },
});